import React from 'react'

//* Components
import Icon from 'components/common/Icon'
import CustomLink from 'components/common/CustomLink'

//* styles
import HeaderCartAccountStyle from './style'

//* Config
import config from 'helpers/_config'
import { withUIContext, withCartContext } from 'context'

//* svg
import { Account, Cart } from 'svg'

const HeaderCartAccount = ({ isBurgerMenuOpen, itemsCount }) => {
    return (
        <HeaderCartAccountStyle>
            <CustomLink
                url={config.routes.account.path}
                className={`inline-block ${isBurgerMenuOpen ? 'hide' : ''}`}
                rel={'noopener noreferrer'}
                ariaLabel={'Profile link'}
            >
                <Account className={'icon-profile'} />
            </CustomLink>
            <CustomLink
                url={config.routes.cart.path}
                className={`inline-block ${isBurgerMenuOpen ? 'hide' : ''} cart-icon-cont`}
                rel={'noopener noreferrer'}
                ariaLabel={'Cart link'}
            >
                <Cart className={'icon-cart'} />
                {!!itemsCount && <span className="items-count">{itemsCount}</span>}
            </CustomLink>
        </HeaderCartAccountStyle>
    )
}

export default withCartContext(withUIContext(HeaderCartAccount, ['isBurgerMenuOpen']), ['itemsCount'])
